import React from 'react';
import type { OrbitOpportunityItem, OrbitOverview } from '../../types/aai';

/*
 * Phase 6: what running looks like once something is built.
 *
 * Held deliberately thin. The lighthouse metrics, the value ledger against the
 * baselines, and the queue where an agent waits for a yes before it writes to
 * a client's system all belong to work that has not been built yet, and drawing
 * them with invented numbers would make the one page that has to be trustworthy
 * the least trustworthy. What is real here is the work already in delivery, so
 * that is what this shows, with the rest named as what comes next.
 */

export const RunView: React.FC<{
  overview: OrbitOverview;
  onBack: () => void;
  onOpenProjects: () => void;
}> = ({ overview, onBack, onOpenProjects }) => {
  const items: OrbitOpportunityItem[] = overview.opportunities.items || [];
  const live = items.filter((i) => i.request_id);

  return (
    <>
      <div className="det-head">
        <button type="button" className="back" onClick={onBack}>← Company</button>
        <h1>Run: agents work, people oversee</h1>
        <span className="pct"><b>{live.length}</b> in delivery</span>
      </div>
      <div className="dept-intro">
        Agents do the day-to-day and your people oversee them. Anything that writes to your own systems waits for a person to say yes,
        every time, and any agent can be paused from Connections & access.
      </div>
      {live.length === 0 && (
        <div className="empty">
          <strong>Nothing is running yet.</strong>
          Confirm an opportunity and it becomes a project. Once it is delivered, it appears here with what it does and who oversees it.
          <button type="button" onClick={onOpenProjects}>Open projects</button>
        </div>
      )}
      {live.map((item) => (
        <div key={item.id} className="agent-card">
          <span className="av">{item.level.slice(0, 2).toUpperCase()}</span>
          <div>
            <strong>{item.title}</strong>
            <small>{item.level} · for {item.for}{item.stage ? ` · ${item.stage}` : ''}</small>
          </div>
          <span className="mets"><b>{item.state}</b></span>
        </div>
      ))}
      {live.length > 0 && (
        <div className="aux-row">
          <span>Value measured against the baselines set in phases 1 and 2 is the next piece of this screen.</span>
          <div className="aux-acts">
            <button type="button" onClick={onOpenProjects}>Open projects</button>
          </div>
        </div>
      )}
    </>
  );
};

export default RunView;
